import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

type PatientWhatsAppSchedulingNoticeProps = {
	onAlter?: () => void;
	className?: string;
};

const PatientWhatsAppSchedulingNotice = ({
	onAlter,
	className,
}: PatientWhatsAppSchedulingNoticeProps) => (
	<div
		className={cn(
			'flex items-start gap-2 rounded-lg border border-emerald-100 bg-emerald-50/70 px-3 py-2',
			className,
		)}
	>
		<MessageCircle
			className="mt-0.5 size-3 shrink-0 text-emerald-600"
			strokeWidth={2.25}
			aria-hidden
		/>
		<p className="min-w-0 text-[11px] leading-snug text-emerald-800">
			Notificação automática no WhatsApp após o agendamento.
			{onAlter ? (
				<>
					{' '}
					<button
						type="button"
						onClick={onAlter}
						className="font-semibold text-emerald-900 underline underline-offset-2 transition hover:text-emerald-950"
					>
						alterar
					</button>
				</>
			) : null}
		</p>
	</div>
);

export { PatientWhatsAppSchedulingNotice };
